export default __webpack_public_path__ + "static/media/widowmaker-noonecanhide-fr.6d6d39ca.mp3";